import { FC, useMemo, useState } from 'react';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';
import { VyRadioGroup } from '../../../../../components/new-design/inputs/VyRadio/VyRadioGroup';
import { VyRadio } from '../../../../../components/new-design/inputs/VyRadio/VyRadio';
import { PLAN_CREATION_REASONS } from '../../../../../contexts/create-plan-context/create-plan-context-types/plan-create-reason';
import { DuplicatePlanSavingOption } from './types/duplicate-plan-saving-option';
import { VyDescriptionTitle } from '../../../../../components/new-design/data-display/VyDescriptionTitle/VyDescriptionTitle';
import { OPTION_ITEMS, OptionItem } from './saving-options';
import { duplicateOptionsDialogSelectors, getSelectorAttribute } from '@vy/app-selectors';

type DuplicateOptionsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (duplicatePlanSavingOption: DuplicatePlanSavingOption) => void;
};

export const DuplicateOptionsDialog: FC<DuplicateOptionsDialogProps> = ({ isOpen, onClose, onSubmit }) => {
  const [duplicatePlanSavingOption, setDuplicatePlanSavingOption] = useState<DuplicatePlanSavingOption>(
    PLAN_CREATION_REASONS.NewContract,
  );

  const handlePlanCreateReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDuplicatePlanSavingOption(event.target.value as DuplicatePlanSavingOption);
  };

  const radioGroupOptions = useMemo(() => createRadioGroupOptions(OPTION_ITEMS), []);

  return (
    <VyDialog
      label="Saving options"
      disableDividers
      open={isOpen}
      onClose={onClose}
      ctaText="Next"
      cancelButtonText="Cancel"
      onSubmit={() => onSubmit(duplicatePlanSavingOption)}
    >
      <VyRadioGroup
        value={duplicatePlanSavingOption}
        onChange={handlePlanCreateReasonChange}
        horizontal
        options={radioGroupOptions}
        renderOption={({ value, label }, _, isActive) => (
          <span
            key={value}
            {...getSelectorAttribute(
              value === PLAN_CREATION_REASONS.NewPlan
                ? duplicateOptionsDialogSelectors.saveAsTemplateOption
                : duplicateOptionsDialogSelectors.startNewContractOption,
            )}
          >
            <VyRadio
              value={value}
              label={label}
              labelSx={{
                padding: '24px',
                flex: 1,
                border: `1px solid ${isActive ? '#5083FF' : '#E8EBF2'}`,
                borderRadius: '8px',
                backgroundColor: `${isActive ? '#F5F6FA' : '#FFFFFF'}`,
                '&:hover': {
                  backgroundColor: '#F5F6FA',
                  borderColor: '#B0D2FF',
                },
              }}
            />
          </span>
        )}
      />
    </VyDialog>
  );
};

function createRadioGroupOptions(optionItems: OptionItem[]) {
  return optionItems.map(({ value, label: { title, subTitle } }) => ({
    value,
    label: <VyDescriptionTitle title={title} subTitle={subTitle} />,
  }));
}
